// Traductions Postinity — confirmations & messages d'activation.
const fr = {
  c_act_cer1: "Activer votre cérémonie et la mettre au coffre-fort numérique ? Tout reste modifiable à tout moment.",
  c_confirm2: "Confirmez-vous l'activation de votre cérémonie ? (2ᵉ confirmation)",
  c_deact2: "Confirmez-vous la désactivation ? (2ᵉ confirmation)",
  c_deact_garants: "Désactiver vos garants ?",
  c_deact_cer: "Désactiver votre cérémonie ?",
  c_del_video: "Supprimer la vidéo ?",
  c_del_music: "Supprimer votre musique importée ? La bibliothèque reste disponible.",
  c_del_msg: "⚠️ Êtes-vous vraiment sûr ? Cette action est définitive et le message (texte, photos, vidéo, fichiers) sera perdu.",
  t_cer_guard: "Validez d'abord toutes les étapes (tout doit être vert) avant d'activer votre cérémonie.",
  t_all_validated: "Toutes vos étapes sont validées 🎉",
};
const en = {
  c_act_cer1: "Activate your ceremony and put it in the digital vault? Everything remains editable at any time.",
  c_confirm2: "Do you confirm activating your ceremony? (2nd confirmation)",
  c_deact2: "Do you confirm the deactivation? (2nd confirmation)",
  c_deact_garants: "Deactivate your guardians?",
  c_deact_cer: "Deactivate your ceremony?",
  c_del_video: "Delete the video?",
  c_del_music: "Delete your imported music? The library remains available.",
  c_del_msg: "⚠️ Are you really sure? This action is final and the message (text, photos, video, files) will be lost.",
  t_cer_guard: "First validate all steps (everything must be green) before activating your ceremony.",
  t_all_validated: "All your steps are validated 🎉",
};
const es = {
  c_act_cer1: "¿Activar tu ceremonia y ponerla en la caja fuerte digital? Todo sigue siendo modificable en cualquier momento.",
  c_confirm2: "¿Confirmas la activación de tu ceremonia? (2ª confirmación)",
  c_deact2: "¿Confirmas la desactivación? (2ª confirmación)",
  c_deact_garants: "¿Desactivar tus garantes?",
  c_deact_cer: "¿Desactivar tu ceremonia?",
  c_del_video: "¿Eliminar el vídeo?",
  c_del_music: "¿Eliminar tu música importada? La biblioteca sigue disponible.",
  c_del_msg: "⚠️ ¿Estás realmente seguro? Esta acción es definitiva y el mensaje (texto, fotos, vídeo, archivos) se perderá.",
  t_cer_guard: "Valida primero todas las etapas (todo debe estar en verde) antes de activar tu ceremonia.",
  t_all_validated: "Todas tus etapas están validadas 🎉",
};
const de = {
  c_act_cer1: "Ihre Zeremonie aktivieren und im digitalen Safe ablegen? Alles bleibt jederzeit änderbar.",
  c_confirm2: "Bestätigen Sie die Aktivierung Ihrer Zeremonie? (2. Bestätigung)",
  c_deact2: "Bestätigen Sie die Deaktivierung? (2. Bestätigung)",
  c_deact_garants: "Ihre Bürgen deaktivieren?",
  c_deact_cer: "Ihre Zeremonie deaktivieren?",
  c_del_video: "Video löschen?",
  c_del_music: "Ihre importierte Musik löschen? Die Bibliothek bleibt verfügbar.",
  c_del_msg: "⚠️ Sind Sie wirklich sicher? Diese Aktion ist endgültig und die Nachricht (Text, Fotos, Video, Dateien) geht verloren.",
  t_cer_guard: "Bestätigen Sie zuerst alle Schritte (alles muss grün sein), bevor Sie Ihre Zeremonie aktivieren.",
  t_all_validated: "Alle Ihre Schritte sind bestätigt 🎉",
};
const it = {
  c_act_cer1: "Attivare la tua cerimonia e metterla nella cassaforte digitale? Tutto resta modificabile in qualsiasi momento.",
  c_confirm2: "Confermi l'attivazione della tua cerimonia? (2ª conferma)",
  c_deact2: "Confermi la disattivazione? (2ª conferma)",
  c_deact_garants: "Disattivare i tuoi garanti?",
  c_deact_cer: "Disattivare la tua cerimonia?",
  c_del_video: "Eliminare il video?",
  c_del_music: "Eliminare la tua musica importata? La libreria resta disponibile.",
  c_del_msg: "⚠️ Sei davvero sicuro? Questa azione è definitiva e il messaggio (testo, foto, video, file) andrà perso.",
  t_cer_guard: "Convalida prima tutte le fasi (tutto deve essere verde) prima di attivare la tua cerimonia.",
  t_all_validated: "Tutte le tue fasi sono convalidate 🎉",
};
const pl = {
  c_act_cer1: "Aktywować ceremonię i umieścić ją w cyfrowym sejfie? Wszystko pozostaje zmienialne w każdej chwili.",
  c_confirm2: "Czy potwierdzasz aktywację ceremonii? (2. potwierdzenie)",
  c_deact2: "Czy potwierdzasz dezaktywację? (2. potwierdzenie)",
  c_deact_garants: "Dezaktywować gwarantów?",
  c_deact_cer: "Dezaktywować ceremonię?",
  c_del_video: "Usunąć wideo?",
  c_del_music: "Usunąć zaimportowaną muzykę? Biblioteka pozostaje dostępna.",
  c_del_msg: "⚠️ Czy na pewno? Ta czynność jest nieodwracalna, a wiadomość (tekst, zdjęcia, wideo, pliki) zostanie utracona.",
  t_cer_guard: "Najpierw zatwierdź wszystkie etapy (wszystko musi być zielone) przed aktywacją ceremonii.",
  t_all_validated: "Wszystkie etapy zatwierdzone 🎉",
};
const fil = {
  c_act_cer1: "I-activate ang seremonya at ilagay sa digital vault? Nananatiling mababago ang lahat anumang oras.",
  c_confirm2: "Kinukumpirma mo ba ang pag-activate ng seremonya? (ika-2 kumpirmasyon)",
  c_deact2: "Kinukumpirma mo ba ang pag-deactivate? (ika-2 kumpirmasyon)",
  c_deact_garants: "I-deactivate ang mga tagapangalaga?",
  c_deact_cer: "I-deactivate ang seremonya?",
  c_del_video: "Burahin ang video?",
  c_del_music: "Burahin ang na-import na musika? Mananatiling available ang library.",
  c_del_msg: "⚠️ Sigurado ka ba talaga? Permanente ito at mawawala ang mensahe (teksto, larawan, video, files).",
  t_cer_guard: "I-validate muna ang lahat ng hakbang (dapat berde lahat) bago i-activate ang seremonya.",
  t_all_validated: "Na-validate na ang lahat ng hakbang 🎉",
};
const ru = {
  c_act_cer1: "Активировать церемонию и поместить её в цифровой сейф? Всё остаётся изменяемым в любой момент.",
  c_confirm2: "Подтверждаете активацию церемонии? (2-е подтверждение)",
  c_deact2: "Подтверждаете деактивацию? (2-е подтверждение)",
  c_deact_garants: "Деактивировать поручителей?",
  c_deact_cer: "Деактивировать церемонию?",
  c_del_video: "Удалить видео?",
  c_del_music: "Удалить импортированную музыку? Библиотека остаётся доступной.",
  c_del_msg: "⚠️ Вы действительно уверены? Это действие необратимо, и послание (текст, фото, видео, файлы) будет потеряно.",
  t_cer_guard: "Сначала подтвердите все этапы (всё должно быть зелёным), прежде чем активировать церемонию.",
  t_all_validated: "Все ваши этапы подтверждены 🎉",
};
const el = {
  c_act_cer1: "Ενεργοποίηση της τελετής και τοποθέτηση στο ψηφιακό χρηματοκιβώτιο; Όλα παραμένουν επεξεργάσιμα.",
  c_confirm2: "Επιβεβαιώνετε την ενεργοποίηση της τελετής; (2η επιβεβαίωση)",
  c_deact2: "Επιβεβαιώνετε την απενεργοποίηση; (2η επιβεβαίωση)",
  c_deact_garants: "Απενεργοποίηση των εγγυητών σας;",
  c_deact_cer: "Απενεργοποίηση της τελετής σας;",
  c_del_video: "Διαγραφή του βίντεο;",
  c_del_music: "Διαγραφή της μουσικής που εισαγάγατε; Η βιβλιοθήκη παραμένει διαθέσιμη.",
  c_del_msg: "⚠️ Είστε πραγματικά σίγουροι; Η ενέργεια είναι οριστική και το μήνυμα (κείμενο, φωτογραφίες, βίντεο, αρχεία) θα χαθεί.",
  t_cer_guard: "Επικυρώστε πρώτα όλα τα βήματα (όλα πρέπει να είναι πράσινα) πριν ενεργοποιήσετε την τελετή.",
  t_all_validated: "Όλα τα βήματά σας επικυρώθηκαν 🎉",
};
const hi = {
  c_act_cer1: "अपना समारोह सक्रिय करके डिजिटल तिजोरी में रखें? सब कुछ कभी भी बदला जा सकता है।",
  c_confirm2: "क्या आप अपने समारोह की सक्रियता की पुष्टि करते हैं? (दूसरी पुष्टि)",
  c_deact2: "क्या आप निष्क्रिय करने की पुष्टि करते हैं? (दूसरी पुष्टि)",
  c_deact_garants: "अपने ज़मानतदार निष्क्रिय करें?",
  c_deact_cer: "अपना समारोह निष्क्रिय करें?",
  c_del_video: "वीडियो हटाएँ?",
  c_del_music: "अपना आयातित संगीत हटाएँ? लाइब्रेरी उपलब्ध रहेगी।",
  c_del_msg: "⚠️ क्या आप वाकई निश्चित हैं? यह क्रिया अंतिम है और संदेश (पाठ, तस्वीरें, वीडियो, फ़ाइलें) खो जाएगा।",
  t_cer_guard: "अपना समारोह सक्रिय करने से पहले सभी चरण मान्य करें (सब हरा होना चाहिए)।",
  t_all_validated: "आपके सभी चरण मान्य हैं 🎉",
};
const ja = {
  c_act_cer1: "セレモニーを有効化してデジタル金庫に入れますか？いつでも変更可能です。",
  c_confirm2: "セレモニーの有効化を確認しますか？（2回目の確認）",
  c_deact2: "無効化を確認しますか？（2回目の確認）",
  c_deact_garants: "保証人を無効化しますか？",
  c_deact_cer: "セレモニーを無効化しますか？",
  c_del_video: "動画を削除しますか？",
  c_del_music: "読み込んだ音楽を削除しますか？ライブラリは引き続き利用できます。",
  c_del_msg: "⚠️ 本当によろしいですか？この操作は取り消せず、メッセージ（テキスト・写真・動画・ファイル）は失われます。",
  t_cer_guard: "セレモニーを有効化する前に、すべてのステップを確定してください（すべて緑になる必要があります）。",
  t_all_validated: "すべてのステップが確定しました 🎉",
};
const zh = {
  c_act_cer1: "激活您的仪式并存入数字保险库？一切随时可修改。",
  c_confirm2: "确认激活您的仪式？（第二次确认）",
  c_deact2: "确认停用？（第二次确认）",
  c_deact_garants: "停用您的担保人？",
  c_deact_cer: "停用您的仪式？",
  c_del_video: "删除视频？",
  c_del_music: "删除您导入的音乐？音乐库仍然可用。",
  c_del_msg: "⚠️ 您真的确定吗？此操作不可逆，留言（文字、照片、视频、文件）将会丢失。",
  t_cer_guard: "在激活仪式之前，请先确认所有步骤（全部必须为绿色）。",
  t_all_validated: "您的所有步骤均已确认 🎉",
};

export const postinity6 = { fr, en, es, es_mx: es, de, it, pl, fil, ru, el, hi, ja, zh };
